import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema } from '@/core/components';

import { defaultPublicationValues, publicationSchema } from '../../Publication/model/PublicationSchema';

export const textSchema = publicationSchema.extend({
  publisher: identitySchema,
  publisherType: identitySchema.nullable(),
});

export const defaultTextValues: DefaultValues<TextSchema> = {
  publisherType: null,
  ...defaultPublicationValues,
};

export type TextSchema = z.infer<typeof textSchema>;
